/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */
import autobind from "autobind-decorator";
import {ObjectUtils} from "./ObjectUtils";
import jmespath from "jmespath";

export class GenericModelUtils {
	static findFieldDefinition(fieldDefs, groupName, key) {
		const fieldDefGroup = fieldDefs?.find((x) => x.key === groupName) ?? null;
		return fieldDefGroup?.value?.find((x) => x.key === key) ?? null;
	}
	
	// static getKey(model, data) {
	// 	return model.getPrimaryKeyValue(data);
	// }
	
	static getOptionsForGroup = (fieldGroup) => {
		return {
			renderer: model.groupRenderers?.[fieldGroup.key] ?? 'StandardModelViewerRenderer'
		}
	}

	// static fieldIsVisible(field) {
	// 	const { EditMode, HasPermission, Data, RootData, CustomData } = this.props;
	//
	// 	// primary key is always hidden
	// 	// if the user could change this they
	// 	// might overwrite other data unintentionally
	// 	if(field.isPrimaryKey) {
	// 		return false;
	// 	}
	//
	// 	// if this field is a child of an association
	// 	// it should be hidden if the association is hidden
	// 	if(field.association && !this.fieldIsVisible(field.association)) {
	// 		return false;
	// 	}
	//
	// 	// hide based on viewerOnly and editorOnly rules
	// 	if((EditMode ? field.viewerOnly : field.editorOnly)) {
	// 		return false;
	// 	}
	//
	// 	// hide nullable associations {
	// 	if(this.isHiddenNullableAssociationField(field)) {
	// 		return false;
	// 	}
	//
	// 	let isHidden = false;
	//
	// 	if(typeof field.isHidden == 'object') {
	// 		const { query, requiresPermission } = field.isHidden;
	// 		const SearchContext = ObjectUtils.Merge(ObjectUtils.Clone(Data), { __RootData: RootData, __CustomData: CustomData });
	//
	// 		if(query) {
	// 			isHidden = isHidden || jmespath.search(SearchContext, query);
	// 		}
	// 		if(requiresPermission) {
	// 			isHidden = isHidden || !HasPermission(requiresPermission);
	// 		}
	// 	} else {
	// 		isHidden = isHidden || field.isHidden;
	// 	}
	//
	// 	return !isHidden;
	// }

	static isHiddenNullableAssociationField(fieldDef, data) {
		const association = fieldDef.association;

		if(association && association.name && !fieldDef.isNullableAssociationFieldToggle) {
			// if data is null and the association is nullable
			// (note: !isOne && ArrayOfChildren relationships
			// are not nullable)
			return data[association.name] == null && (
				(
					association.type == 'ParentPointer' &&
					association.isNullable
				) || (
					association.type == "ArrayOfChildren" &&
					association.isOne &&
					association.isNullable
				)
			);
		}
		return false;
	}
}
